import React from 'react';
import Plot from 'react-plotly.js';

const Scatter3DPlot = ({ data, xKey, yKey, zKey, colorKey }) => {
  
  if (zKey == null || zKey == undefined || zKey.length == 0 || data.length == 0) {
    return (<>
    </>);
  }
  const plotData = {
    x: data[xKey],
    y: data[yKey],
    z: data[zKey],
    mode: 'markers',
    marker: {
      size: 12,
    },
    type: 'scatter3d'
  };

  if (colorKey && data[colorKey]) {
    plotData.marker.color = data[colorKey];
    plotData.marker.colorscale = 'Viridis';
    plotData.marker.showscale = true;
  }

  return (
    <Plot
      data={[plotData]}
      layout={{
        title: '3D Scatter Plot',
        scene: {
          xaxis: { title: xKey },
          yaxis: { title: yKey },
          zaxis: { title: zKey }
        },
        width: 700,
        height: 700
      }}
      useResizeHandler={true}
    />
  );
};

export default Scatter3DPlot;
